const appHeight = () => {
    const body = document.body
    body.style.setProperty('--app-body-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)

export {
    appHeight
}